module.exports = __webpack_public_path__ + "img/logoec.bada9609.png";